export default [
    {
        path: '/rest/:linkedtype/:linkedid/statistics',
        name: 'overview.statistics',
    },

]